import { IChangeTrack } from '../contracts/tracking/change-track';

export class ChangeTrackContainer {
  constructor(public path = '', public changeTrack: IChangeTrack | undefined) {}
}
